var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJake({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_382",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29251",
    "data-name": "Group 29251",
    transform: "translate(435 10935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -435, -10935)",
    filter: "url(#Ellipse_382)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_382-2",
    "data-name": "Ellipse 382",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-jake",
    transform: "translate(-416 -10919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50146",
    "data-name": "Path 50146",
    d: "M30.6,16.969c0,1.33,0,4.654-1.995,4.654a2.811,2.811,0,0,1-1.995-.665v9.974H7.99V20.958a2.811,2.811,0,0,1-1.995.665C4.029,21.623,4,18.3,4,16.969,4,11.649,8.654,5,17.3,5S30.6,11.649,30.6,16.969Z",
    fill: "#fbc02d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50147",
    "data-name": "Path 50147",
    d: "M25.979,24s-.479,3.365-2.666,4.369l-.04.02c-.02.007-.04.02-.06.027a.96.96,0,0,0,.106-.426c0-.731-.891-1.33-1.995-1.33a2.166,2.166,0,0,0-1.829.8,2.041,2.041,0,0,1-.193-.226A8.085,8.085,0,0,1,18,24a7.467,7.467,0,0,0,3.99,1.33A7.467,7.467,0,0,0,25.979,24Z",
    transform: "translate(-4.691 -6.366)",
    fill: "#821616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50148",
    "data-name": "Path 50148",
    d: "M24.073,29.33a.96.96,0,0,1-.106.426,3.261,3.261,0,0,1-1.223.239,3.175,3.175,0,0,1-2.387-1.064.972.972,0,0,1-.106-.126,2.166,2.166,0,0,1,1.829-.8C23.182,28,24.073,28.6,24.073,29.33Z",
    transform: "translate(-5.445 -7.707)",
    fill: "#e57373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50149",
    "data-name": "Path 50149",
    d: "M29.608,29.665v9.309H27.613V29A2.811,2.811,0,0,0,29.608,29.665ZM8.995,29v9.974H7V29.665A2.811,2.811,0,0,0,8.995,29Z",
    transform: "translate(-1.005 -8.042)",
    fill: "#f9a825"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50150",
    "data-name": "Path 50150",
    d: "M20.649,16.01c-7.62.186-6.946,6.7-6.252,8.637.424,1.177,1.306,1.995,2.084,1.995,2.084,0,2.445-3.378,2.779-5.319a1.4,1.4,0,0,1,2.778,0c.333,1.942.695,5.319,2.779,5.319.778,0,1.66-.818,2.084-1.995C27.6,22.706,28.269,16.2,20.649,16.01Z",
    transform: "translate(-3.351 -3.689)",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28949",
    "data-name": "Group 28949",
    transform: "translate(8.654 9.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50151",
    "data-name": "Path 50151",
    d: "M14.684,16.419a5.167,5.167,0,0,0-1.35,2.148,3.326,3.326,0,0,1,.093-6.377,2.89,2.89,0,0,0-.432,1.536A2.971,2.971,0,0,0,14.684,16.419Zm13.6-.864a3.317,3.317,0,0,1-2.327,3.012,5.368,5.368,0,0,0-4.282-3.6A3.313,3.313,0,0,1,23.733,12.3a2.906,2.906,0,0,0-.1.765,2.988,2.988,0,0,0,2.992,2.992A2.945,2.945,0,0,0,28.281,15.555Zm-8.637,1.829c-1.469,0-2.66.6-2.66,1.33s1.191,1.33,2.66,1.33,2.66-.6,2.66-1.33S21.113,17.383,19.644,17.383Z",
    transform: "translate(-11 -12.19)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28950",
    "data-name": "Group 28950",
    transform: "translate(10.649 9.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50152",
    "data-name": "Path 50152",
    d: "M18.621,14.9a6.029,6.029,0,0,0-2.932,1.456A2.971,2.971,0,0,1,14,13.662a2.89,2.89,0,0,1,.432-1.536,3.083,3.083,0,0,1,.9-.126A3.319,3.319,0,0,1,18.621,14.9Zm10.672.426a1.39,1.39,0,0,1-.007.166,2.945,2.945,0,0,1-1.656.5A2.988,2.988,0,0,1,24.639,13a2.906,2.906,0,0,1,.1-.765A3.429,3.429,0,0,1,25.969,12,3.326,3.326,0,0,1,29.293,15.325Z",
    transform: "translate(-14 -12)",
    fill: "#fafafa"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJake);
export default __webpack_public_path__ + "static/media/jake.3abac52393c5640b8345a2b3cf418d7f.svg";
export { ForwardRef as ReactComponent };